// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageCategoryItem-manageServiceCardImgContainer-YgQdb {
    position: relative;
    background: var(--background-quaternary);
    -webkit-box-shadow: 0px 5px 23px 0px var(--shadow-1);
            box-shadow: 0px 5px 23px 0px var(--shadow-1);
    padding: 24px 28px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    border-radius: 12px 0 12px 0;
}

.ManageCategoryItem-manageServiceCardImgWrapper-fAKnp {
    position: relative;
    width: 80px;
    height: 80px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ManageCategoryItem-manageServiceCardInfo-imB6F {
    margin-top: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: var(--primary-foreground);
    text-align: center;
}

.ManageCategoryItem-manageServiceCardSelectIcon-v1kCF {
    position: absolute;
    bottom: 6px;
    right: 6px;
    width: 18px;
    height: 18px;
    z-index: 1;
}

.ManageCategoryItem-manageServiceCardImg-L8JKx,
.ManageCategoryItem-manageServiceCardSelectIcon-v1kCF img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ManageCategory/ManageCategoryItem/ManageCategoryItem.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,oDAA4C;YAA5C,4CAA4C;IAC5C,kBAAkB;IAClB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B","sourcesContent":[".manageServiceCardImgContainer {\n    position: relative;\n    background: var(--background-quaternary);\n    box-shadow: 0px 5px 23px 0px var(--shadow-1);\n    padding: 24px 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px 0 12px 0;\n}\n\n.manageServiceCardImgWrapper {\n    position: relative;\n    width: 80px;\n    height: 80px;\n    flex-shrink: 0;\n}\n\n.manageServiceCardInfo {\n    margin-top: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 26px;\n    color: var(--primary-foreground);\n    text-align: center;\n}\n\n.manageServiceCardSelectIcon {\n    position: absolute;\n    bottom: 6px;\n    right: 6px;\n    width: 18px;\n    height: 18px;\n    z-index: 1;\n}\n\n.manageServiceCardImg,\n.manageServiceCardSelectIcon img {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageServiceCardImgContainer": `ManageCategoryItem-manageServiceCardImgContainer-YgQdb`,
	"manageServiceCardImgWrapper": `ManageCategoryItem-manageServiceCardImgWrapper-fAKnp`,
	"manageServiceCardInfo": `ManageCategoryItem-manageServiceCardInfo-imB6F`,
	"manageServiceCardSelectIcon": `ManageCategoryItem-manageServiceCardSelectIcon-v1kCF`,
	"manageServiceCardImg": `ManageCategoryItem-manageServiceCardImg-L8JKx`
};
module.exports = ___CSS_LOADER_EXPORT___;
